"use strict";
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        /**
         * Adds context menu option for the form name and control name, handling the case of the target control
         * not having an equivalent serverform control, in that case it walks up the parents until it finds one
         * @internal
         * @param event The event that triggered the context menu request.
         * @param formName The active form name.
         * @param contextControl The context of the control for which to generate the context menu option.
         * @param contextMenuOptionsList The in/out parameter containing the menu/menu items to populate.
         */
        function getContextMenuOptions(event, formName, contextControl, contextMenuOptionsList) {
            var target = event.target;
            var personalizeOptionObj = { Label: "ContextMenu_Personalize" };
            var formPersonlizationName = "FormControlPersonalization"; // this is very tied to AX - the name must remain the same in order to disable the form info button
            personalizeOptionObj.contextMenuOptions = [];
            contextMenuOptionsList.push(personalizeOptionObj);
            var formOption = {
                Command: function () {
                    var command = contextControl.ExecutePersonalizationCommand;
                    if (command === undefined && contextControl && contextControl.Root) {
                        command = contextControl.Root.ExecutePersonalizationCommand;
                    }
                    if (contextControl && command && contextControl.Root && !contextControl.Root.isPopup()) {
                        $dyn.callFunction(command, contextControl, ["LaunchFormPersonalizationPane"]);
                    }
                },
                Enabled: $dyn.value(formName) !== formPersonlizationName,
                Label: $dyn.format($dyn.label("ContextMenu_FormName"), $dyn.value(formName)),
                Name: "GoTo_Form",
            };
            personalizeOptionObj.contextMenuOptions.push(formOption);
            var controlName;
            // The control may not be data-bound, in that case there is no context
            // Check the context control's element first, then the event target
            var element = null;
            if ($dyn.context(contextControl.element)) {
                element = contextControl.element;
            }
            else if ($dyn.context(target)) {
                element = target;
            }
            var controlParamsObj;
            if (element) {
                controlParamsObj = $dyn.serverForm.getElementControlParams(element);
                if (controlParamsObj) {
                    controlName = $dyn.value(controlParamsObj.Name);
                }
            }
            else {
                // Fall back on the name passed in in the context control
                controlName = $dyn.value(contextControl.Name);
            }
            if (controlName) {
                var controlOption = {
                    Command: function () {
                        var confirmExit = $dyn.flags.confirmExit;
                        $dyn.flags.confirmExit = false;
                        location.assign($dyn.format("dynamics://Navigation/Form/{0}/Control/{1}", encodeURIComponent($dyn.value(formName)), encodeURIComponent(controlName)));
                        $dyn.flags.confirmExit = false;
                        // Set on a timeout to allow the location.assign to fire first
                        $dyn.async(function () { $dyn.flags.confirmExit = confirmExit; }, undefined, "Reset confirmExit after setting context menu control name.");
                    },
                    Label: $dyn.format($dyn.label("ContextMenu_ControlName"), controlName),
                    Name: $dyn.format("GoTo_{0}", controlName)
                };
                personalizeOptionObj.contextMenuOptions.push(controlOption);
            }
            var contextSubControl = contextControl;
            var searchName = controlName ? controlName : $dyn.value(contextControl.Name);
            var subControl = contextControl.Root && contextControl.Root.findControl(searchName);
            if (subControl) {
                controlParamsObj = $dyn.serverForm.getElementControlParams(subControl);
                if (controlParamsObj) {
                    controlName = $dyn.value(controlParamsObj.Name);
                }
            }
            if (controlParamsObj && controlName && contextControl && contextControl.Root) {
                // if this is a client-only control composing a server control (i.e. a button within file upload or header of a gird)
                // redirect the search to the real server control
                // tslint:disable-next-line: no-shadowed-variable
                var subControl_1 = contextControl.Root.findControl(controlName);
                if (subControl_1) {
                    contextSubControl = $dyn.context(subControl_1);
                    controlName = contextSubControl.Name;
                }
                else {
                    contextSubControl = null;
                    controlName = "";
                }
            }
            if (contextSubControl && contextSubControl.Root && !contextControl.Root.isPopup()) {
                var personalizationOptionsObj = $dyn.ax.formPersonalizationPane.formPersonalizationController.getPersonalizationOptions(controlName, contextSubControl);
                if (personalizationOptionsObj) {
                    contextMenuOptionsList.push(personalizationOptionsObj);
                }
            }
        }
        ax.getContextMenuOptions = getContextMenuOptions;
    })(ax = $dyn.ax || ($dyn.ax = {}));
    $(document).on("contextmenuoptions", $dyn.ax.getContextMenuOptions);
})($dyn || ($dyn = {}));

//# sourceMappingURL=AXForms.js.map
